import { fabric } from 'fabric';
import getStroke from 'perfect-freehand';
// import polygonClipping from 'polygon-clipping';
import { getSvgPathFromStroke } from './LudusBrush';
// import set from 'lodash-es/set';

const extraPropsToSave = [
  'points',
  'size',
  'thinning',
  'smoothing',
  'streamline',
  'simulatePressure',
];

const LudusBrushPath = fabric.util.createClass(fabric.Object, {
  type: 'ludusBrushPath',
  points: [],
  width: 100,
  height: 100,
  top: 0,
  left: 0,
  size: 10,
  thinning: 0.7,
  smoothing: 0.5,
  streamline: 0.5,
  simulatePressure: false,
  originX: 'center',
  originY: 'center',

  initialize(options = {}, currentStroke) {
    this.initialized = false;
    const _options = {
      ...options,
      ludus: { ...options.ludus, type: 'brushPath' },
    };
    if (_options.points && currentStroke) {
      this._stroke = currentStroke;
      const bbox = this.getBBox(this._stroke);
      _options.width = bbox.width;
      _options.height = bbox.height;
      _options.top = bbox.top;
      _options.left = bbox.left;
      _options.points = this.transformPoints(
        _options.points,
        _options.left,
        _options.top,
      );
      this._stroke = getStroke(_options.points, {
        ..._options,
      });
      this.pathData = getSvgPathFromStroke(this._stroke);
      this.path = new Path2D(this.pathData);
    } else if (_options.points) {
      this._stroke = getStroke(_options.points, {
        ..._options,
      });
      const bbox = this.getBBox(this._stroke);
      _options.width = bbox.width;
      _options.height = bbox.height;
      this.pathData = getSvgPathFromStroke(this._stroke);
      this.path = new Path2D(this.pathData);
    }
    this.callSuper('initialize', _options);

    this.initialized = true;
  },

  updateStroke: function() {
    this._stroke = getStroke(this.points, {
      size: this.size,
      thinning: this.thinning,
      smoothing: this.smoothing,
      streamline: this.streamline,
      simulatePressure: this.simulatePressure,
    });
    const bbox = this.getBBox(this._stroke);

    this.width = bbox.width;
    this.height = bbox.height;
    this._stroke = this.transformPoints(this._stroke, bbox.left, bbox.top);
    this.points = this.transformPoints(this.points, bbox.left, bbox.top);

    this.pathData = getSvgPathFromStroke(this._stroke);
    this.path = new Path2D(this.pathData);
    this.canvas.requestRenderAll();
  },

  _renderControls: function(ctx, styleOverride) {
    this.hasControls = this.canvas.isDrawingMode ? false : this.hasControls;
    this.callSuper('_renderControls', ctx, styleOverride);
  },

  transformPoints: function(points, left, top) {
    const newPoints = points.map(p => {
      const newP = [...p];
      newP[0] = Math.round((p[0] - left) * 100) / 100;
      newP[1] = Math.round((p[1] - top) * 100) / 100;
      return newP;
    });
    return newPoints;
  },

  getBBox: function(points) {
    let minX = null;
    let minY = null;
    let maxX = null;
    let maxY = null;

    points.forEach(point => {
      const y = point[1];
      const x = point[0];
      if (x > maxX || !maxX) {
        maxX = x;
      }
      if (x < minX || !minX) {
        minX = x;
      }
      if (y > maxY || !maxY) {
        maxY = y;
      }
      if (y < minY || !minY) {
        minY = y;
      }
    });

    const width = maxX - minX;
    const height = maxY - minY;
    const left = minX + width / 2;
    const top = minY + height / 2;
    return {
      width,
      height,
      top,
      left,
    };
  },

  _set(key, value) {
    this.callSuper('_set', key, value);

    if (!this.initialized) {
      return this;
    }

    if (key === 'size') {
      this.updateStroke();
      return this;
    }

    return this;
  },

  toObject(propertiesToInclude = []) {
    return this.callSuper('toObject', [
      ...propertiesToInclude,
      ...extraPropsToSave,
    ]);
  },

  _toSVG() {
    return ['<path ', 'COMMON_PARTS', `d="${this.pathData}"/>\n`];
  },

  _render(ctx) {
    if (this.path && this.path !== '{}') {
      ctx.fill(this.path, 'nonzero');
    }
  },
});

LudusBrushPath.fromObject = function fromObject(object, callback) {
  const options = fabric.util.object.clone(object, true);
  callback && callback(new LudusBrushPath(options));
};

export default LudusBrushPath;
